import React from "react";

function ReferralHospitals() {
    const referralHospitals = [
        "Amara Hospital - 0877 6690000",
        "SVIMS Hospital - 0877 2287777",
        "Ramadevi Hospital",
        "Krishna scan centre will give special discounts to our employees on institute doctor prescription.",
    ];
    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <div>
                <h2>Referral Hospitals</h2>
                <ul>
                    {referralHospitals.map((item, index) => (
                        <li
                            key={index}
                            className="caboutus"
                            style={{ display: "flex", flexDirection: "row" }}
                        >
                            <i
                                className="icon fal fas fa-caret-right pl-5"
                                style={{
                                    display: "block",
                                    alignSelf: "flex-start",
                                    marginTop: "0.31lh",
                                }}
                            />
                            <p className="pl-10">{item}</p>
                        </li>
                    ))}
                </ul>
            </div>

            <br />

            <div>
                <h2>Labs</h2>
                <div
                    className="caboutus"
                    style={{ display: "flex", flexDirection: "row" }}
                >
                    <i
                        className="icon fal fas fa-caret-right pl-5"
                        style={{
                            display: "block",
                            alignSelf: "flex-start",
                            marginTop: "0.31lh",
                        }}
                    />
                    <p className="pl-10">Thyrocare diagnostics</p>
                </div>
            </div>

            <br />

            <div>
                <h3>MOU with Pharmacies</h3>
                <div
                    className="caboutus"
                    style={{ display: "flex", flexDirection: "row" }}
                >
                    <i
                        className="icon fal fas fa-caret-right pl-5"
                        style={{
                            display: "block",
                            alignSelf: "flex-start",
                            marginTop: "0.31lh",
                        }}
                    />
                    <p className="pl-10">
                        Apollo pharmacy - korlakunta, Renigunta,Tiruchanuru
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ReferralHospitals;
